export enum StatisticGroupsEnum {
  OFFER = "OFFER",
  ADVERTISER = "ADVERTISER",
  WEBMASTER = "WEBMASTER",
  MANAGER = "MANAGER",
  DAY = "DAY",
  MONTH = "MONTH"
}